import { useCrudActions } from '@/common/view/useCrudActions';
import { appleService } from '@/services/apple';
import useVuelidate from '@vuelidate/core';
import { numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useApple() {
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        isNew: true,
        appStoreId: null,
        appBundleId: '',
        appSharedSecret: ''
    });

    const validations = {
        appStoreId: { required, numeric },
        appBundleId: { required },
        appSharedSecret: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        request: appleService.get,
        onSuccess: ({ data }) => {
            model.isNew = false;
            model.appStoreId = data.appStoreId;
            model.appBundleId = data.appBundleId;
            model.appSharedSecret = data.appSharedSecret;
        },
        onError: () => {
            model.isNew = true;
            model.appStoreId = null;
            model.appBundleId = '';
            model.appSharedSecret = '';
        }
    });

    const actions = {
        update: excuteAndNotify({
            request: () => appleService.update(model.appStoreId, model.appBundleId, model.appSharedSecret),
            onSuccess: fetch,
            validator: v$
        }),
        remove: confirmAndRemove({
            request: appleService.remove,
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
